import { withInstall } from '@lit-element/utils'
import Row from './src/row.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtRow: SFCWithInstall<typeof Row> = withInstall(Row)
export default LtRow

export * from './src/row'
export * from './src/constants'
